import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { concat, isEmpty, get, assign } from 'lodash';

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
} from '@material-ui/core';


import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';

import { Form as FormUI } from '~/components/Form';

//import { storeOperacaoSolicitacaoAtendimento, updateOperacaoSolicitacaoAtendimento } from '~/store/modules/operacaosolicitacaoatendimento/actions';

import { storeOperacaoLiberacaoRemota } from '~/store/modules/operacaoliberacaoremota/actions';

import {
  t,
  FormatarCodigoLiberacao,
  trocarCaracteresRetornaSomenteNumero,
  validarCPF,
} from '~/helpers';

import api from '~/services/api';

import { GFO, GFU } from '~/constants/perfil';

//import solicitacaoAtendimentoInitials from './solicitacaoAtendimentoInitials';
//import dadosAtendimentoVO from './dadosAtendimentoVO';

import InserirLibRemota from '../InserirLibRemota';

import DetalheLibRemota from '../DetalheLibRemota';


//import DadosAtendimentoItens from '../Tabs/DadosAtendimentoItens'
//import DadosAtendimento from '../Tabs/DadosAtendimento'
//import TipoAgenda from '../TipoAgenda';


const Form = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const formRef = React.useRef(ref);

  //const modalTipoAgendaRef = React.useRef(null);
  //const [data, setData] = useState({});

  const [data, setData] = useState({});

  const { profile } = useSelector((state) => state.user);

  const { onCloseModal, formEdit } = props;

  const { params } = useSelector(
    (state) => state.operacaoliberacaoremota
  );

  const [initials, setInitials] = useState({
    //...solicitacaoAtendimentoInitials,
    operacao: '',
  });

  const [liberacaoRemota, setLiberacaoRemota] = React.useState({});

  const [isLoading, setIsLoading] = useState(false);

  const [value, setValue] = React.useState(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [btnConfirmar, setBtnConfirmar] = React.useState(true);

  const [btnConfirmarLabel, setBtnConfirmarLabel] = React.useState('Confirmar');

  // Open Modal
  const openModal = React.useCallback(() => {
    setOpen(true);
  }, []);

  // Close Modal
  const closeModal = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleCallbackClose = React.useCallback(() => {
    setData({});
    onCloseModal();
  }, []);


  React.useEffect(() => {
    if (!isEmpty(formEdit)) {
      //const [listaAtendimentoAlteracao, listaAtendimento] = await  Promise.all([buscaListaAtendimento() ,carregaListaAtendimento() ]);
      //setIsLoading(true);
    } else {
      const objSend = {
        //...solicitacaoAtendimentoInitials,
        operacao: '',
      };
      setInitials(objSend);
      setData(objSend);
      //setLoading(true);
    }
  }, [formEdit]);

  // Schema Validade
  const schemaValidade = React.useMemo(
    () =>
      Yup.object().shape({
        poco_codigo: Yup.number()
          .positive()
          .nullable(true)
          .required(t('s.geral.validacao.campoobrigatorio')),
        bico_numero: Yup.number()
          .positive()
          .nullable(true)
          .required(t('s.geral.validacao.campoobrigatorio')),

        cond_cpf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(11, t('s.geral.validacao.tamanhominimo').replace('%s', 11))
          .max(11, t('s.geral.validacao.tamanhomaximo').replace('%s', 11))
          .test('cpf-invalid', t('s.configuracao.geral.cpfinvalido'), function (
            value
          ) {
            return validarCPF(value);
          }),

        veic_placa_apresentacao: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))         
          .min(7, t('s.geral.validacao.tamanhominimo').replace('%s', 7))
          .max(7, t('s.geral.validacao.tamanhomaximo').replace('%s', 7)),

        km_liberacao: Yup.string()
        
          .typeError('Somente valor inteiro!')
          .transform((value) => (isNaN(value) ? 0 : value))
          // .required(t('s.geral.validacao.campoobrigatorio'))
          // .positive('O Km deve ser maior que 0!')
          
          .matches(/^\d*\.?\d{0,1}$/g, 'Somente uma casa decimal para o campo KM!')

          .test(
             'len',
             'O Km deve maior que 0 e menor que 9999999! ',
             (val) => val && val <= 9999999
           ),
          
          
          // .test(
          //   'len',
          //   'O Km deve maior que 0 e menor que 9999999! ',
          //   (val) => val && val <= 9999999
          // ),

        // km_liberacao: Yup.number()
        //   //.min(1, 'Must be exactly 1 characters')
        //   //.max(9999999, 'Must be exactly 9999999 characters')
        //   .typeError('Somente valor inteiro!')
        //   .transform((value) => (isNaN(value) ? 0 : value))
        //   .required(t('s.geral.validacao.campoobrigatorio'))
        //   .positive('O Km deve ser maior que 0!')
        //   .nullable(true)
          
        //   //.integer('Somente valor inteiro!')
        //   .test(
        //     'len',
        //     'O Km deve maior que 0 e menor que 9999999! ',
        //     (val) => val && val <= 9999999
        //   ),


      }),
    [initials, data]
  );


  async function getLiberaAbastecimento(data) {
    try {
      setIsLoading(true);

      const poco_desc_abrev = data.poco_desc_abrev;
      const idTerminal = data.term_identificacao;
      const bico_numero = data.bico_numero;
      const placa = data.veic_placa_apresentacao;
      const cpf = trocarCaracteresRetornaSomenteNumero(data.cond_cpf, '');
      const km = data.km_liberacao;


      const response = await api.get(
        `/tcoudtmgliberaabastecimento/${idTerminal}/${bico_numero}/${placa}/${cpf}/${km}`
      );
      await setIsLoading(false);
      const statusRetorno = get(response, 'data.retorno', '');

      if (String(statusRetorno) === '') {
        toast.error('Não foi possível fazer a consulta!');
        return;
      }

      if (response && !isEmpty(response.data)) {

        if (String(response.data.retorno) !== 'OK') {
          toast.error(response.data.msgErro);
          return;
        } else {


          const kmantes = get(response.data, 'kmanterior', '0');


          //Retirei essa condicional 
          //25022022
          //Pedido SEPLAG
          //Voltar depois do carnaval
          if (Number(kmantes) > Number(km)) {
            handleClickListItem();
          } else {

            const codigo1 = get(response.data, 'codigo1', '');
            const codigo2 = get(response.data, 'codigo2', '');
            const posto = data.poco_codigo;
            const login = get(profile, 'glousuariologin', '');
            const codliberacao = get(response.data, 'impedimento', '');
            const preco = get(response.data, 'preco', '');

            const objSend = {
              codigo1,
              codigo2,
              bico_numero,
              posto,
              placa,
              cpf,
              login,
              km,
              codliberacao,
              preco,
            };

            const objLiberado = {              
                codigo1,
                codigo2,
                bico_numero,
                posto,
                placa,
                cpf,
                login,
                km,
                codliberacao,
                preco,   
                poco_desc_abrev,           
            }

            

            setLiberacaoRemota(objLiberado);

            if (String(response.data.retorno) === 'OK') {

              setIsLoading(true);

              //setFecharForm(true);

              //await dispatch(storeOperacaoLiberacaoRemota(objSend, params));


              await api.post('operacaoliberacaoremotas', objSend);

              toast.success(t('s.geral.sucessoinclusao'));
              setBtnConfirmar(false);

              setIsLoading(false);



            }

          }


        }
      } else {
        setLiberacaoRemota('');
      }

    } catch (err) {
      setLiberacaoRemota('');
      setIsLoading(false);
      toast.error(` ${err} `);
    }
  }



  //DIALOG ********************** */    
  const [openCheckKM, setOpenCheckKM] = React.useState(false);
  const [valueCheckKM, setValueCheckKM] = React.useState('CLICK-OK');
  const handleClickListItem = () => {
    setOpenCheckKM(true);
  };
  const handleClose = (newValue) => {
    setOpenCheckKM(false);
    if (newValue) {
      setValueCheckKM(newValue);
    }
  };

  function ConfirmationDialogRaw(props) {
    const { onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = React.useState(valueProp);
    const radioGroupRef = React.useRef(null);

    React.useEffect(() => {
      if (!open) {
        setValue(valueProp);
      }
    }, [valueProp, open]);

    const handleEntering = () => {
      if (radioGroupRef.current != null) {
        radioGroupRef.current.focus();
      }
    };

    const handleCancel = () => {
      onClose();
    };

    const handleOk = () => {
      onClose(value);
    };

    // const handleChange = (event) => {
    //   setValue(event.target.value);
    // };

    return (
      <div>



        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="xs"
          onEntering={handleEntering}
          aria-labelledby="confirmation-dialog-title"
          open={open}
          {...other}
        >
          <DialogTitle id="confirmation-dialog-title">Confirmar</DialogTitle>
          <DialogContent dividers>
            <span>O KM anterior é maior que o KM atual. Deseja Salvar?</span>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCancel} color="primary">
              Cancel
          </Button>
            <Button onClick={handleOk} color="primary">
              Ok
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  //DIALOG ********************** */    



  // Submit form
  const handleSubmit = React.useCallback(
    async (data, { reset }) => {
      const dados = { ...initials, ...data };
      try {



        await schemaValidade.validate(dados, {
          abortEarly: false,
        });

        setIsLoading(true);

        await getLiberaAbastecimento(data);

        //setBtnConfirmar(false);
        //setBtnConfirmarLabel('Fui')
        return


      } catch (err) {
        setIsLoading(false);
        const validationErrors = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });
          formRef.current.setErrors(validationErrors);
        }
      }
    },
    [initials, data]
  );

  // Export functions
  React.useImperativeHandle(ref, () => ({
    openModal,
  }));

  const onChangeValue = useCallback((campo, value) => {

  });

  return (
    <>

      {isLoading ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div>
      ) : (
        ''
      )}

      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        open={open}
        maxWidth="sm"
        onExit={handleCallbackClose}
      >
        <DialogTitle>{'Liberação Remota'}</DialogTitle>
        <DialogContent >
          <FormUI
            ref={formRef}
            initialData={data}
            onSubmit={handleSubmit}
          >

            {btnConfirmar &&
              <InserirLibRemota initials={isEmpty(formEdit) ? data : initials}
                reference={formRef}
                onChangeValue={onChangeValue}
              />
            }

            {!btnConfirmar &&
              <DetalheLibRemota initials={liberacaoRemota}
                reference={formRef}
                onChangeValue={onChangeValue}
              />
            }

          </FormUI>
        </DialogContent>

        <DialogActions>
          {btnConfirmar &&
            <Button
              onClick={() => { formRef.current.submitForm(); }}
              color="primary"
              variant="outlined"
            //disabled={!btnConfirmar}
            >
              {btnConfirmarLabel}
            </Button>
          }
          <Button onClick={closeModal} color="secondary" variant="outlined">
            {t('s.geral.botaofechar')}
          </Button>
        </DialogActions>
      </Dialog>



      <div>
        <ConfirmationDialogRaw
          id="ringtone-menu"
          keepMounted
          open={openCheckKM}
          onClose={handleClose}
          value={valueCheckKM}
        />
      </div>


    </>
  );
});

Form.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  formEdit: PropTypes.objectOf(PropTypes.any),
};

Form.defaultProps = {
  formEdit: {},
};

export default Form;
